import { React, PT, withRouter } from '@gasbuddy/react';
import moment from 'moment';
import { Table } from 'semantic-ui-react';

const BaseFeatureTable = ({ assignments, history }) => (
  <Table basic="very" selectable style={{ tableLayout: 'fixed', fontSize: '0.9em' }}>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Feature</Table.HeaderCell>
        <Table.HeaderCell>Variant</Table.HeaderCell>
        <Table.HeaderCell width={2}>Assigned On</Table.HeaderCell>
        <Table.HeaderCell width={2} textAlign="center">Version</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {assignments.map(a => (
        <Table.Row key={a.internal_name}>
          <Table.Cell onClick={() => history.push(`/system/features/${a.feature_id}`)}>
            {a.feature_name}
            {' '}
(
            {a.internal_name}
)
          </Table.Cell>
          <Table.Cell onClick={() => history.push(`/system/features/variants/${a.feature_variant_id}`)}>{a.name}</Table.Cell>
          <Table.Cell>{moment(a.assigned_at).format('M/DD/YY HH:mm')}</Table.Cell>
          <Table.Cell textAlign="center">{a.feature_version}</Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
);

BaseFeatureTable.propTypes = {
  assignments: PT.arrayOf(PT.shape({
    name: PT.string,
    feature_name: PT.string,
    internal_name: PT.string,
    feature_version: PT.number,
  })),
  history: PT.shape({
    push: PT.func,
  }).isRequired,
};

BaseFeatureTable.defaultProps = {
  assignments: [],
};

export const FeatureTable = withRouter(BaseFeatureTable);
